import { createBrowserRouter, Navigate } from 'react-router-dom';
import App from './App';
import HomePage from './pages/HomePage';
import MeetingPage from './pages/MeetingPage';
import VotePage from './pages/VotePage';
import ExpensePage from './pages/ExpensePage';
import SettlementPage from './pages/SettlementPage';
import LoginPage from './pages/LoginPage';
import InvitePage from './pages/InvitePage';
import OAuthCallbackPage from './pages/OAuthCallbackPage';
import ProfilePage from './pages/ProfilePage';
import PlacePage from './pages/PlacePage';
import PayKakaoResultPage from './pages/PayKakaoResultPage';
import RoomsPage from './pages/RoomsPage';
import RoomPage from './pages/RoomPage';
import ExpenseSuggestPage from './pages/ExpenseSuggestPage';
import TransferSuggestPage from './pages/TransferSuggestPage';
import ChatPage from './pages/ChatPage';
import ScheduleItemPage from './pages/ScheduleItemPage';
import MeetingPointPage from './pages/MeetingPointPage';
import LivePage from './pages/LivePage';
import { ProtectedRoute } from './shared/ProtectedRoute';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <div className="p-6">문제가 발생했어요. 잠시 후 다시 시도해주세요.</div>,
    children: [
      // 루트('/')는 nginx가 랜딩을 서빙한다. 앱 홈은 /home.
      // SPA 내부에서 '/'로 흘러오면(예: 클라이언트 네비게이션) /home 으로 보낸다.
      { index: true, element: <Navigate to="/home" replace /> },
      { path: 'home', element: <ProtectedRoute><HomePage /></ProtectedRoute> },
      { path: 'rooms', element: <ProtectedRoute><RoomsPage /></ProtectedRoute> },
      { path: 'rooms/:id', element: <ProtectedRoute><RoomPage /></ProtectedRoute> },
      { path: 'meetings/:id', element: <ProtectedRoute><MeetingPage /></ProtectedRoute> },
      { path: 'meetings/:id/vote', element: <ProtectedRoute><VotePage /></ProtectedRoute> },
      { path: 'meetings/:id/chat', element: <ProtectedRoute><ChatPage /></ProtectedRoute> },
      { path: 'meetings/:id/live', element: <ProtectedRoute><LivePage /></ProtectedRoute> },
      { path: 'meetings/:id/places', element: <ProtectedRoute><PlacePage /></ProtectedRoute> },
      { path: 'meetings/:id/schedule/:scheduleItemId', element: <ProtectedRoute><ScheduleItemPage /></ProtectedRoute> },
      { path: 'meetings/:id/point', element: <ProtectedRoute><MeetingPointPage /></ProtectedRoute> },
      { path: 'meetings/:id/expense', element: <ProtectedRoute><ExpensePage /></ProtectedRoute> },
      { path: 'meetings/:id/settlement', element: <ProtectedRoute><SettlementPage /></ProtectedRoute> },
      { path: 'profile', element: <ProtectedRoute><ProfilePage /></ProtectedRoute> },
      { path: 'pay/kakao/result', element: <ProtectedRoute><PayKakaoResultPage /></ProtectedRoute> },
      { path: 'expense-suggest', element: <ProtectedRoute><ExpenseSuggestPage /></ProtectedRoute> },
      { path: 'transfer-suggest', element: <ProtectedRoute><TransferSuggestPage /></ProtectedRoute> },
      { path: 'login', element: <LoginPage /> },
      { path: 'invite/:token', element: <InvitePage /> },
      { path: 'auth/callback', element: <OAuthCallbackPage /> },
    ],
  },
]);
